export default __webpack_public_path__ + "static/media/gallery-wip-handle_06.953542a1.jpg";